/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AccessMember, AccessMember$inboundSchema } from "./accessmember.js";

export type ListMembersResult = {
  /**
   * The members in your organization.
   */
  members: Array<AccessMember>;
};

/** @internal */
export const ListMembersResult$inboundSchema: z.ZodMiniType<
  ListMembersResult,
  unknown
> = z.object({
  members: z.array(AccessMember$inboundSchema),
});

export function listMembersResultFromJSON(
  jsonString: string,
): SafeParseResult<ListMembersResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListMembersResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListMembersResult' from JSON`,
  );
}
